export const contactsData = {
    email: 'ishankvasania09@gmail.com',
    phone: '+91  9551848957',
    address: 'Seattle, Washington, US',

    sheetAPI: ''
}